import { useRef, useCallback } from 'react'

/**
 * Props pour un backdrop de modale : ne ferme que si mousedown ET click
 * sont tous deux sur le backdrop (évite de fermer quand on sélectionne du texte
 * dans la modale et qu’on relâche la souris dehors).
 *
 * @param {((e?: React.MouseEvent) => void) | null | undefined} onDismiss
 * @returns {{ onMouseDown: (e: React.MouseEvent) => void, onClick: (e: React.MouseEvent) => void }}
 */
export function useBackdropDismiss(onDismiss) {
  const downOnBackdropRef = useRef(false)

  const onMouseDown = useCallback((e) => {
    downOnBackdropRef.current = e.target === e.currentTarget
  }, [])

  const onClick = useCallback(
    (e) => {
      if (e.target !== e.currentTarget) return
      if (downOnBackdropRef.current) onDismiss?.(e)
      downOnBackdropRef.current = false
    },
    [onDismiss]
  )

  return { onMouseDown, onClick }
}
